// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"OtherA_TheComp__cLhgh","TheComp2":"OtherA_TheComp2__0DJId","EmailBox":"OtherA_EmailBox__gk0GR","CompIcon":"OtherA_CompIcon__mmnBc"};